import { render, staticRenderFns } from "./listaFornecedor.vue?vue&type=template&id=043a8b7d&scoped=true&"
import script from "./listaFornecedor.vue?vue&type=script&lang=js&"
export * from "./listaFornecedor.vue?vue&type=script&lang=js&"
import style0 from "./listaFornecedor.vue?vue&type=style&index=0&id=043a8b7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043a8b7d",
  null
  
)

export default component.exports